/**
 * Vue 全局混用
 * 
 * @author qingguipeng
 * @email qingguipeng@Foxmail.com
 * @date 2019年10月20日 18:41:51
 */

import { Dialog, Toast } from 'vant';
import { mapState } from 'vuex';
import moment from 'moment';
import storage from "@/utils/storage";
import numeral from 'numeral';
import { Decimal } from 'decimal.js'
import $md5 from 'js-md5'
export default {
    computed: {
        ...mapState(['userInfo']),
    },
    components: {
        [Dialog.Component.name]: Dialog.Component
    },
    data() {
        return {
        }
    },

    methods: {
        _isLogin() {
            return (this.userInfo != null && this.userInfo.userName);
        },

        _loginOr(func) {
            if (this._isLogin()) {
                if (func) {
                    func();
                }
            } else {
                this._routeLogin();
            }
        },

        /**
         * 统一跳转
         */
        _routeLogin() {
            this._routePush('LoginPage');
        },

        _routeReplace(path, query) {
            this.$router.replace({
                path,
                query,
            });
        },

        _routePush(path, query) {
            this.$router.push({
                path,
                query,
            });
        },

        /**
         * 路由跳转带有query参数
         */
        _routePushQ(path, query) {
            this.$router.push({
                path,
                query,
            });
        },

        /**
         * 显示Toast
         */
        _showToast(msg) {
            Toast(msg);
        },

        /**
         * 显示打钩消息
         */
        _showSuccess(msg) {
            Toast.success(msg);
        },

        /**
         * 请登录
         * @params options{Object}
         *  - mustLogin{Boolean} // 是否必须登录
         * @returns{Boolean}  // true 已登录/ false 未登录
         */
        _confirmLogin(options = {}) {
            let token = storage.get("app-token");
            let user_info = storage.getJson('user-info');
            if (token && user_info) return true;

            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
            return false;
        },

        /**
         * 请确认您还是新人
         * @returns 
         *  - true // 是新人
         *  - false // 不是新人
         */
        _confirmNewcom(msg_obj) {

        },

        /**
         * 请确认您已经评测
         * @returns 
         *  - true // 已经评测
         *  - false // 没有评测
         */
        _confirmRisk(msg_obj) {

        },

        /**
         * 路由回退或者历史回退
         */
        _routerBack() {
            this.$router ? this.$router.back() : window.history.back();
        },

        /**
         * 显示Loading
         */
        _showLoading() {
            Toast.loading({
                overlay: true,
                duration: 0,
                loadingType: 'spinner',
                message: '加载中...'
            });
        },

        /**
         * 不显示Loading
         */
        _dismissLoading() {
            Toast.clear();
        },

        // 将base64文件转换为二进制
        _dataURLtoBlob(dataUrl) {
            let arr = dataUrl.split(',');
            let mime = arr[0].match(/:(.*?);/)[1];
            let bstr = atob(arr[1]);
            let n = bstr.length;
            let u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        },
        dateFormat(date, format) {
            return moment(date).format(format);
        },

        numFormat(value, format) {
            format = format || "0,0.00";
            return numeral(value / 100).format('0,0.00');
        },
        numFormat2(value, format) {
            format = format || "0,0.00";
            return numeral(value).format(format);
        },
        /**
         * 手机号码中间4位加*号
         * @param {*} mobile 
         */
        mobileStare(mobile) {
            if (mobile.length > 7) {
                return mobile.substring(0, 3) + '****' + mobile.substring(7, mobile.length)
            } else {
                return mobile.substring(0, mobile.length - 1) + '****'
            }
        },

        /**
         * 前往顶部
         * @params position 位移
         */
        _onScrollyTo(position) {
            if (!window.requestAnimationFrame) {
                window.requestAnimationFrame = function (callback, element) {
                    return setTimeout(callback, 17);
                };
            }
            // 当前滚动高度
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            // 滚动step方法
            var step = function () {
                // 距离目标滚动距离
                var distance = position - scrollTop;
                // 目标滚动位置
                scrollTop = scrollTop + distance / 5;
                if (Math.abs(distance) < 1) {
                    window.scrollTo(0, position);
                } else {
                    window.scrollTo(0, scrollTop);
                    requestAnimationFrame(step);
                }
            };
            step();
        },
        // 全局返回上一页，如果没有上一页返回首页
        goableBack() {
            console.log('goableBack == %O, window.history == %O', window.history.length, window.history);
            if (window.history.length <= 1) {
                this.$router.push({ name: "home" })
                // this.$router.push("/home")
            } else {
                this.$router.go(-1)
                // setTimeout(() => {
                //     location.reload()
                // }, 10);
            }
        },
        //判断是否是微信浏览器的函数
        isWechant() {
            let ua = window.navigator.userAgent.toLowerCase()
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                return true
            } else {
                return false
            }
        },

        startVibrate() {
            //震动
            navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
            if (navigator.vibrate) {
                navigator.vibrate(2000)
            }
        },
        _showTipsInfo(title, content, leftBtn, rightBtn, sureCallback, calncelCallback, align = 'left') {
            Dialog.alert({
                title: title || '温馨提示',
                message: content,
                confirmButtonText: rightBtn,
                cancelButtonText: leftBtn || '',
                showCancelButton: leftBtn,
                messageAlign: align,
                theme: 'round-button'
            }).then(() => sureCallback())
                .catch(() => calncelCallback())
        },
        /**
         * 判断当前年月和需要比较的年月是否相同
         * @param {*} dateStr 格式 202311
         */
        _isExistYearMonth(dateStr, format = 'YYYYMM') {
            let currentDate = moment(Date.now()).format(format)
            return currentDate === dateStr
        },
        /**
         * 判断用户是否仅天安客户，即非机构和其他团队
         * @returns 
         */
        _isOnlyTaCust() {
            return this.userInfo && ['ta'].includes(this.userInfo.custChannel.toLowerCase()) &&
                (!this.userInfo.orgReferrerUserId ||
                    this.userInfo.orgReferrerUserId.length == 0)
        },
        /**
         * 判断用户仅天安金交中心合格投资者（渠道、机构客户除外）
         * @returns 
         */
        _isOnlyTaQualifiedInvestor() {
            return this.userInfo.custType > 0 && this._isOnlyTaCust()
        },
        /**
         * 是否显示双11图标
         * @returns 
         */
        _isOnlyShowShuang11Icon() {
            return this._isExistYearMonth('202310') && this._isOnlyTaCust()
        },

        /**
         * 是否在活动时间内
         * @returns 
         */
        _isActivityDuring() {
            const startTimestamp = new Date('2024-05-01 00:00:00').getTime()
            const endTimestamp = new Date('2024-06-30 23:59:59').getTime()
            const serverTime = (this.userInfo.serverTime || 0)
            return serverTime >= startTimestamp && endTimestamp - serverTime > 0
        },

        // 加
        _addDecimal(x, y) {
            if (!x) {
                x = 0
            }
            if (!y) {
                y = 0
            }
            return new Decimal(x).plus(new Decimal(y)).toNumber()
        },

        // 减
        _reduceDecimal(x, y) {
            if (!x) {
                x = 0
            }
            if (!y) {
                y = 0
            }
            return new Decimal(x).sub(new Decimal(y)).toNumber()
        },

        // 乘
        _rideDecimal(x, y) {
            if (!x) {
                x = 0
            }
            if (!y) {
                y = 0
            }
            return new Decimal(x).mul(new Decimal(y)).toNumber()
        },

        // 除
        _exceptDecimal(x, y) {
            if (!x) {
                x = 0
            }
            if (!y) {
                y = 0
            }
            return new Decimal(x).div(new Decimal(y)).toNumber()
        },

        // 加密
        _getEncryption(r) {
            let serverSign = ''
            for (let i = 0; i < r.length; i += 2) {
                serverSign = this.md5WithFixedSalt(r, r.charAt(i))
            }
            return serverSign
        },
        // 生成随机字符串
        _generateRandomString(length = 8) {
            let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=[]{}|;:,.<>?';
            let result = '';
            for (let i = 0; i < length; i++) {
                const randomIndex = Math.floor(Math.random() * chars.length);
                result += chars[randomIndex];
            }
            return result;
        },
        // md5加密，固定盐值
        md5WithFixedSalt(text, salt, isToLower = true) {
            if (!text || text.length == 0) {
                return ''
            }
            let str = text
            for (let i = 0; i < 4; i++) {
                str += salt
                str = $md5(str)
            }
            if (isToLower) {
                return str.toLowerCase()
            }
            return str.toUpperCase()
        }
    }
}

import Vue from 'vue'

// 防多次点击，重复提交指令，默认为0.5s
const preventReClick = Vue.directive('preventReClick', {
    inserted: function (el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 500);
            }
        })
    }
});

export { preventReClick }
